import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { DefaultFuelSpec, FuelSpecsStoreState } from '@navstation-portal/fuel-specs/data-model/fuel-spec';
import { signalStoreFeature } from '@ngrx/signals';
import { EntityId, setEntities } from '@ngrx/signals/entities';
import { on } from '@ngrx/signals/events';
import { fuelSpecsEvents } from './fuel-specs-events';
import { fuelSpecEntityConfig } from './fuel-specs-store';
import { buildFuelSpecLookupIdMap } from './fuel-specs-vm-builders';

type FuelSpecsEntityState = {
  fuelSpecIds: EntityId[];
  fuelSpecEntityMap: Record<EntityId, DefaultFuelSpec>;
};

export function withFuelSpecsReducers() {
  return signalStoreFeature(
    withTrackedReducer(
      on(
        fuelSpecsEvents.fetchDefaultFuelSpecs,
        (): Partial<FuelSpecsStoreState> => ({
          isFetchingDefaultFuelSpecs: true,
          fetchError: undefined,
        })
      ),
      on(
        fuelSpecsEvents.fetchDefaultFuelSpecsSuccess,
        ({ payload: fuelSpecs }, state): Partial<FuelSpecsStoreState> => ({
          ...setEntities(fuelSpecs, fuelSpecEntityConfig)(state as FuelSpecsStoreState & FuelSpecsEntityState),
          isFetchingDefaultFuelSpecs: false,
          fuelSpecByGradeAndIso: buildFuelSpecLookupIdMap(fuelSpecs),
          lastFetched: Date.now(),
        })
      ),
      on(
        fuelSpecsEvents.fetchDefaultFuelSpecsFailed,
        ({ payload: error }, state): Partial<FuelSpecsStoreState> => ({
          ...setEntities(
            [] as DefaultFuelSpec[],
            fuelSpecEntityConfig
          )(state as FuelSpecsStoreState & FuelSpecsEntityState),
          isFetchingDefaultFuelSpecs: false,
          fetchError: error.message,
          fuelSpecByGradeAndIso: {},
        })
      ),
      on(
        fuelSpecsEvents.rebuildFuelSpecLookup,
        (_, state): Partial<FuelSpecsStoreState> => ({
          fuelSpecByGradeAndIso: buildFuelSpecLookupIdMap(
            (state as FuelSpecsStoreState & FuelSpecsEntityState).fuelSpecEntityMap
          ),
        })
      )
    )
  );
}
